// eslint-disable-next-line import/prefer-default-export
export const stageMapperObject = [
  { label: 'In Conversation', value: 'IN_CONVERSION' },
  { label: 'Initial Contact', value: 'INITIAL_CONTACT' },
  { label: 'Lost', value: 'LOST' },
  { label: 'Follow Ups', value: 'FOLLOW_UP' },
  { label: 'Closed', value: 'CLOSED' },
  { label: 'Meeting Booked', value: 'MEETING_BOOKED' },
  { label: 'Potential Deals', value: 'POTENTIAL' },
];
export const stageMapperObjectForOne = [
  { label: 'In Conversation', value: 'IN_CONVERSION' },
  { label: 'Initial Contact', value: 'INITIAL_CONTACT' },
  { label: 'Lost', value: 'LOST' },
  { label: 'Follow Ups', value: 'FOLLOW_UP' },
  { label: 'Closed', value: 'CLOSED' },
  { label: 'Meeting Booked', value: 'MEETING_BOOKED' },
  { label: 'Potential Deals', value: 'POTENTIAL' },
];

export const potentialMapperObject = [
  { label: 'Very Likely', value: 'VERY_LIKELY' },
  { label: 'Likely', value: 'LIKELY' },
  { label: 'Not Likely', value: 'NOT_LIKELY' },
];

export const chartPotentialMapperObject = [
  { label: 'Very Likely Deals', value: 'VERY_LIKELY' },
  { label: 'Likely Deals', value: 'LIKELY' },
  { label: 'Not Likely Deals', value: 'NOT_LIKELY' },
];

export const subTypeObject = [
  { label: 'Free Trial', value: 'FREE_TRIAL' },
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Yearly', value: 'YEARLY' },
  { label: 'Cancelled', value: 'CANCELLED' },
];
